import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isAdminTabId } from "../../../components/AdminWorkspace/adminTabs";
import { isUserTabId } from "../../../components/UserWorkspace/userTabs";

export const useRequestNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = useCallback(() => {
    const state = location.state as { adminTab?: string; returnTab?: string } | null;
    const tab = state?.adminTab ?? state?.returnTab;
    if (isAdminTabId(tab) || isUserTabId(tab)) {
      navigate({ pathname: "/", search: `?tab=${tab}` });
      return;
    }
    navigate("/");
  }, [location.state, navigate]);

  return { handleBack };
};
